import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function ConsumerTarget(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    _loadConsumerTargets();
  }, []);

  async function _loadConsumerTargets() {
    await NuxeoClient.instance()
      .fetchConsumerTargets()
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (values) => {
    if (values === null) {
      props.handleChange("consumerTarget", []);
    } else {
      let result = values.map((value) => value.label);
      props.handleChange("consumerTarget", result);
    }
  };

  return (
    // <Tooltip arrow title="Please enter the target consumer for this package">
    <Tooltip arrow title={appText.T120}>
      <Grid item={true} xs={12}>
        <div id="consumerTarget">
          <InputLabel className="field-label field-dropdown" required>
            {appText.T57}
          </InputLabel>
          <Autocomplete
            type={"multi"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"consumerTarget"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
